import React, { FC } from 'react'
import { Grid } from '@mui/material'
import { useAddPopupMessage } from 'src/hooks/ui'
import { useEditProjectTypeRequest } from 'src/hooks/api'
import { ProjectTypeNewForm } from 'src/components/forms'

interface EditableProjectTypeProps {
  id: number;
  name: string;
  onChange: () => void;
  onCancel: () => void;
}

export const EditableProjectType: FC<EditableProjectTypeProps> = ({
  id,
  name,
  onChange,
  onCancel,
}) => {
  const addMessage = useAddPopupMessage()
  const editProjectTypeRequest = useEditProjectTypeRequest({ id })

  const update = ({ displayName }: { displayName: string }) => {
    editProjectTypeRequest.mutate(
      { displayName },
      {
        onSuccess: onChange,
        onError: (error) => addMessage({ type: 'error', text: error.message }),
      }
    )
  }

  return (
    <>
      <Grid item flexGrow={1}>
        <ProjectTypeNewForm
          onSubmit={update}
          initialValues={{ displayName: name }}
          onCancel={onCancel}
        />
      </Grid>
    </>
  )
}